import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeleteModelRes;
export const DeleteModelTodo = createAsyncThunk('AddCategory', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL +  `vehicle_model/${id}`,
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeleteModelRes = res.data
        
    } catch (error) {
        return DeleteModelRes = error.response.data
    }
})
